import { type ComponentProps, memo, type RefObject } from 'react';

import { SCRUBBABLE_THUMBNAIL_INDICATOR_WIDTH } from '~/utils/videoThumbnails';

export type VideoScrubbableThumbnailProps = Pick<ComponentProps<'div'>, 'style'> & {
  backgroundImageRef: RefObject<HTMLDivElement>;
  indicatorRef: RefObject<HTMLDivElement>;
  src: string;
};

export const VideoScrubbableThumbnail = memo(
  ({ backgroundImageRef, indicatorRef, src, style }: VideoScrubbableThumbnailProps) => (
    <div className="pointer-events-none absolute inset-0 size-full overflow-hidden rounded-4">
      <div
        className="size-full bg-cover"
        ref={backgroundImageRef}
        style={{
          backgroundImage: `url("${src}")`,
          ...style,
        }}
      />
      <div
        className="pointer-events-none absolute top-0 left-0 hidden h-full ads:bg-primary bg-blue-9"
        ref={indicatorRef}
        style={{ width: SCRUBBABLE_THUMBNAIL_INDICATOR_WIDTH }}
      />
    </div>
  ),
);

VideoScrubbableThumbnail.displayName = 'VideoScrubbableThumbnail';
